import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 导入 Bootstrap 和 FontAwesome
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

// 导入全局样式
import './assets/css/global.css'
import VueWechatTitle from 'vue-wechat-title'; //统一标题

createApp(App).use(store).use(router).use(VueWechatTitle).mount('#app')
